// extracted by mini-css-extract-plugin
module.exports = {"carousel_wrapper":"AboutUsBottleSliderSection-module--carousel_wrapper--3BJMR","image_carousel":"AboutUsBottleSliderSection-module--image_carousel--3eFlI"};